import React from 'react';

import NarrativeChapter from './NarrativeChapter';

/**
 * Renders an honest, future-facing preview of Milan's post-match direction.
 * Accepts no props.
 *
 * @returns {React.ReactElement} Chapter seven with upcoming Resonance description.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function ResonanceTease({ index = 8 }) {
  return (
    <NarrativeChapter
      index={index}
      id="resonance"
      tone="dark"
      eyebrow="After the match"
      title="Designed not to be deleted."
      body="Milan is designed for what happens after two people choose each other. Matching is not the finish line; it is the start of a quieter relationship space."
    />
  );
}
